import { useEffect } from 'react';
import { useThemeStore } from '@/features/theme';
import { ThemeMode } from '@fretgenius/ui';

const ThemeSelector: React.FC = () => {
  const { mode, setThemeMode } = useThemeStore();

  // Apply the theme to the document when it changes
  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute('data-theme', mode === ThemeMode.Dark ? 'dark' : 'cupcake');
  }, [mode]);

  return (
    <div className="form-control">
      <label className="label">
        <span className="label-text font-medium">Theme</span>
      </label>
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <input
            type="radio"
            name="theme-radio"
            className="radio"
            checked={mode === ThemeMode.Light}
            onChange={() => setThemeMode(ThemeMode.Light)}
          />
          <span>Light</span>
        </div>
        <div className="flex items-center gap-2">
          <input
            type="radio"
            name="theme-radio"
            className="radio"
            checked={mode === ThemeMode.Dark}
            onChange={() => setThemeMode(ThemeMode.Dark)}
          />
          <span>Dark</span>
        </div>
      </div>
    </div>
  );
};

export { ThemeSelector };
